// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__Pqwvq","loaderOuter":"PageOverlayLoader_loaderOuter__2NFCv"};